import { useStyles } from "@webapps/styles";
import { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Calendar } from "@material-ui/pickers";
import { css } from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { format, parseISO, isWithinInterval, startOfMonth, endOfMonth, max, min, eachMonthOfInterval } from "date-fns";
import { useCalendar } from "pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider";
import planningColors from "pages/school/ClassesPage/Classes/colors/planningColors";
import MyCalendar from "./MyCalendar";
const CalendarContainer = memo(({ months, absences, startDate, endDate, isHoliday, getPeriodTypeForDay,
  handleOpenModal, isClassAuthorized, from,
  periods, handleOpenDeleteModal, setResetSelectedDays, holidays,
  containerStyle, calendarStyle
}, ref) => {

  const { state, dispatch } = useCalendar(); // Récupération du contexte


  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(() => styles(state.categoryTotals, state.hoveredPeriodId));

  const calendarRefs = useRef([]);


  /**
   * Transforme un tableau de périodes en un objet organisé par mois et année.
   * @param {Array} periods - Liste des périodes.
   * @returns {Object} - Objet avec les périodes dispatchées par mois.
   */
  const groupPeriodsByMonth = (periods) => {
    const grouped = {};

    periods.forEach(period => {
      const start = parseISO(period.startDate);
      const end = parseISO(period.endDate);

      // Trouver tous les mois traversés par la période
      const monthsInRange = eachMonthOfInterval({ start, end });

      monthsInRange.forEach(monthDate => {
        const monthKey = format(monthDate, "MM-yyyy");
        const monthStart = startOfMonth(monthDate);
        const monthEnd = endOfMonth(monthDate);

        // Déterminer les limites de la période pour ce mois
        const periodStart = max([start, monthStart]); // Débute au max entre le start de la période et le début du mois
        const periodEnd = min([end, monthEnd]); // Termine au min entre la fin de la période et la fin du mois

        // Ajouter cette période découpée au bon mois
        if (!grouped[monthKey]) {
          grouped[monthKey] = [];
        }
        grouped[monthKey].push({
          ...period,
          startDate: format(periodStart, "yyyy-MM-dd"), // Dates affichées dans le calendrier
          endDate: format(periodEnd, "yyyy-MM-dd"),
          realPeriodStartDate: format(start, "yyyy-MM-dd"), // Dates réelles de la période
          realPeriodEndDate: format(end, "yyyy-MM-dd"),
        });
      });
    });


    return grouped;
  };

  const filterPeriodsByMonth = (month) => {
    const test = periods.filter((period) => {
      const start = new Date(period.startDate);
      const end = new Date(period.endDate);
      return start.getMonth() === month.getMonth() && start.getFullYear() === month.getFullYear();
    });
    return test
  }

  function filterHolidaysByMonth(month) {
    const targetMonth = new Date(month).getMonth(); // Récupère le mois (0-11)
    const targetYear = new Date(month).getFullYear(); // Récupère l'année


    const holidaysFormatted = holidays.filter(holiday => {
      const holidayDate = new Date(holiday.date);
      return holidayDate.getMonth() === targetMonth && holidayDate.getFullYear() === targetYear;
    });


    return holidaysFormatted;
  }

  return (
    <div className={cx(classes.calendarsContainer, containerStyle)} >
      {(() => {
        return months.map((month, index) => {


          return (
            <MyCalendar
              month={month}
              periods={filterPeriodsByMonth(month)}
              monthPeriods={groupPeriodsByMonth(periods)[format(month, "MM-yyyy")] ? groupPeriodsByMonth(periods)[format(month, "MM-yyyy")] : []}
              holidays={filterHolidaysByMonth(month)}
              isClassAuthorized={isClassAuthorized}
              handleOpenModal={handleOpenModal}
              handleOpenDeleteModal={handleOpenDeleteModal}
              isHoliday={isHoliday}
              getPeriodTypeForDay={getPeriodTypeForDay}
              absences={absences}
              startDate={startDate}
              endDate={endDate}
              key={index}
              from={from}
              calendarStyle={calendarStyle}
            />
          )
        });
      })()}
    </div >
  )
});

const styles = (categoryTotals, hoveredPeriodId) => ({
  calendarsContainer: {
    display: "flex",
    flexWrap: "wrap",
    // justifyContent: "space-between",
    // padding: "20px",
    borderRadius: "10px",
    // backgroundColor: "red",
    // marginLeft: "20px",
    gap: "10px",
    // gap: "20px calc((100% - (400px*3)) /3) ",
    "@media only screen and (max-width: 1460px)": {
      // gap: "20px calc((100% - (350px*3)) /3) ",
    },
    "@media only screen and (max-width: 1300px)": {
      // gap: "20px calc((100% - (300px*3)) /3) ",
    },
    "@media only screen and (max-width: 1140px)": {
      // gap: "20px calc((100% - (calc(50% - 10px)*2)) /2) ",
    },
    "@media only screen and (max-width: 1140px)": {
      // gap: "20px"
    },
    "@media only screen and (max-width: 900px)": {
      justifyContent: "center",
    },
  },

  calendarWrapper: {
    height: "400px",
    "& .MuiPickersCalendarHeader-iconButton": {
      display: "none !important",
    },
    "& .MuiPickersCalendarHeader-dayLabel": {
      // margin: "3px",
      width: "48px",
    },
    "& .MuiPickersSlideTransition-transitionContainer": {
      marginBottom: "16px",
      "& .MuiTypography-body1": {
        fontSize: "15px",
        fontFamily: "Montserrat",
        textAlign: "start",
        fontWeight: 600,
        color: "#152652",
      },
      "& .MuiTypography-body1::first-letter": {
        textTransform: "uppercase",
      },
    },
    // width: "calc(33.33% - 7px)", // 20px gap + 20px/3 marginLeft = 6.67 arrondi à 7
    // width: "400px",
    // height: "400px",
    padding: "10px",
    backgroundColor: "white",
    borderRadius: "10px",

    "@media only screen and (max-width: 1460px)": {
      // width: "350px",
      // height: "350px",
    },
    "@media only screen and (max-width: 1300px)": {
      // width: "300px",
      // height: "300px",

    },
    "@media only screen and (max-width: 1140px)": {
      // width: "calc(50% - 10px)",
      // height: "350px",
    },

    "@media only screen and (max-width: 900px)": {
      // width: "calc(80% - 20px)",
    },
    "@media only screen and (max-width: 650px)": {
      // width: "350px",
    },
  },

  dayCell: {
    position: "relative",
    // margin: "1px",
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // width: "calc(100% / 7 - 2px)", // 1px de marge de chaque côté
    // borderRadius: "50%",
    // padding: "4px",
    "&.hoveredPeriod": {
      filter: "brightness(0.8)", // Rendre la couleur plus sombre
      cursor: "pointer",

      "& .modifyButton": {
        position: "absolute",
        top: "-30px", // Positionne au-dessus
        right: "10px", // Aligné à droite
        opacity: 0, // Invisible par défaut
        pointerEvents: "none", // Désactive les interactions par défaut
        transition: "opacity 0.3s ease", // Transition fluide
      },

      "&:hover .modifyButton": {
        opacity: 1, // Visible au hover
        pointerEvents: "auto", // Interactions activées
      },
    },

    "& .modifyButtonHover": {
      backgroundColor: "white", // Couleur du bouton
      color: "black",
      border: "none",
      position: "absolute",
      borderRadius: "4px",
      padding: "4px 8px",
      fontSize: "12px",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      filter: "brightness(1)", // Rendre la couleur plus sombre


      "&:hover": {
        backgroundColor: "#3700b3", // Couleur au survol
      },
    },

    "&.disabled": {
      color: "#ccc",
      pointerEvents: "none",
      backgroundColor: "#F0F0F0", // Couleur grise pour les jours hors plage

    },
    "&.holiday": {
      backgroundColor: categoryTotals.FERIES.visible ? planningColors.FERIES : planningColors.FERIES + "B3", // ROUGE pour les jours fériés, B3 a la fin pour 70% de transparence

      "&:hover": {
        // backgroundColor: darkenColor(planningColors.FERIES, 40),
      },
      "& p": {
        color: "white",
      },

    },

    "&.FORMATION": {
      backgroundColor: categoryTotals.FORMATION.visible ? planningColors.FORMATION : planningColors.FORMATION + "B3", // Bleu pour Formation


      "&:hover": {
        // backgroundColor: darkenColor(planningColors.FORMATION, 40),
      },
      "& p": {
        color: "white",
      },

      [`&.FORMATION.period-${hoveredPeriodId}`]: {
        backgroundColor: "#333 !important",
      },
    },
    "&.ENTREPRISE": {
      backgroundColor: categoryTotals.ENTREPRISE.visible ? planningColors.ENTREPRISE : planningColors.ENTREPRISE + "B3", // Violet pour Entreprise


      "&:hover": {
        // backgroundColor: darkenColor(planningColors.ENTREPRISE, 40),
      },
      "& p": {
        color: "white",
      },

    },
    "&.VACANCES": {
      backgroundColor: categoryTotals.VACANCES.visible ? planningColors.VACANCES : planningColors.VACANCES + "B3", // Rose pour Vacances


      "&:hover": {
        // backgroundColor: darkenColor(planningColors.VACANCES, 40),
      },
      "& p": {
        color: "white",
      },

    },
    "&.weekend": {
      backgroundColor: "#F0F0F0", // Couleur grise pour les week-ends
    },
    "&.selectedStart": {
      backgroundColor: '#0060F9',
      color: 'white',
    },
    "&.selectedEnd": {
      backgroundColor: '#0060F9',
      color: 'white',
    },
    "&.selectedRange": {
      backgroundColor: "#C0D9FF",
    },
    "&.outOfMonth": {
      visibility: "visible", // Reste visible pour la structure
      pointerEvents: "none", // Non cliquable
      color: "transparent", // Supprime le texte visible
      backgroundColor: "transparent", // Aucune couleur
    },
  },
  absentBadge: {
    backgroundColor: "red",
    color: "white",
    borderRadius: 4,
    position: "absolute",
    right: 0,
    top: 0
  },
});

export default CalendarContainer;